module.exports = __webpack_public_path__ + "static/media/children_playing_videogames.d82b909e.jpg";